// src/App.js
import GeneratorPage from './pages/GeneratorPage';

const App = () => <GeneratorPage />;

export default App;
